import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { VivaSuiteNavProps } from './VivaSuiteNav';

const vivaSuiteNavLoader = () => import(/* webpackChunkName: "4-feat-viva-suite-nav" */ './VivaSuiteNav');
const LoadableVivaSuiteNav: ComponentType<VivaSuiteNavProps> = lazyLoadOnRender({ loader: vivaSuiteNavLoader });
export default LoadableVivaSuiteNav;
